import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";
import { CommonRequest } from "@/types/http";
import { CpPathway, CpPeranTtd, CpSession } from "@/types/cp";

const base = "/cp/sessions";

function handle(promise: Promise<any>): Promise<any> {
  return promise.catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

async function pathways(): Promise<CommonRequest<CpPathway[]>> {
  const response = await handle(http.getData("/cp/pathways"));
  return response.data;
}

async function create(
  data: Partial<CpSession> & Record<string, any>
): Promise<CommonRequest<any>> {
  const response = await handle(http.postData(base, data));
  return response.data;
}

async function update(
  id: number,
  data: Partial<CpSession> & Record<string, any>
): Promise<CommonRequest<any>> {
  const response = await handle(http.putData(`${base}/${id}`, data));
  return response.data;
}

async function find(id: number): Promise<CommonRequest<any>> {
  const response = await handle(http.getData(`${base}/${id}`));
  return response.data;
}

async function getByRegister(
  register_id: string | number
): Promise<CommonRequest<any>> {
  const response = await handle(http.getData(`${base}/register/${register_id}`));
  return response.data;
}

async function lookupPatient(
  register_id: string | number
): Promise<CommonRequest<any>> {
  const response = await handle(
    http.getData(`/cp/lookup-patient/${register_id}`)
  );
  return response.data;
}

async function destroy(id: number): Promise<CommonRequest<undefined>> {
  const response = await handle(http.deleteData(`${base}/${id}`));
  return response.data;
}

async function updateActivity(
  id: number,
  activityId: number,
  data: Record<string, any>
): Promise<CommonRequest<any>> {
  const response = await handle(
    http.putData(`${base}/${id}/activities/${activityId}`, data)
  );
  return response.data;
}

async function bulkUpdateActivities(
  id: number,
  data: { activity_ids: number[]; status: string }
): Promise<CommonRequest<any>> {
  const response = await handle(
    http.putData(`${base}/${id}/activities/bulk`, data)
  );
  return response.data;
}

async function storeVariance(
  id: number,
  data: Record<string, any>
): Promise<CommonRequest<any>> {
  const response = await handle(http.postData(`${base}/${id}/variances`, data));
  return response.data;
}

async function destroyVariance(
  id: number,
  varianceId: number
): Promise<CommonRequest<any>> {
  const response = await handle(
    http.deleteData(`${base}/${id}/variances/${varianceId}`)
  );
  return response.data;
}

async function sign(
  id: number,
  peran: CpPeranTtd,
  data: any = {}
): Promise<CommonRequest<any>> {
  const response = await handle(
    http.postData(`${base}/${id}/sign/${peran}`, data)
  );
  return response.data;
}

function pdfUrl(id: number): string {
  return `${http.getAPI()}${base}/${id}/pdf`;
}

function printPdf(id: number) {
  window.open(pdfUrl(id), "_blank");
}

export default {
  pathways,
  create,
  update,
  find,
  getByRegister,
  lookupPatient,
  destroy,
  updateActivity,
  bulkUpdateActivities,
  storeVariance,
  destroyVariance,
  sign,
  pdfUrl,
  printPdf
};
